module.exports = __webpack_public_path__ + "static/img/z6.8efab723.png";